"use client"

import { useState, useEffect } from "react"
import { MessageCircle, X } from "lucide-react"
import { cn } from "@/lib/utils"

export function WhatsAppButton() {
    const [isVisible, setIsVisible] = useState(false)
    const [isExpanded, setIsExpanded] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 2000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <div
            className={cn(
                "fixed bottom-4 left-4 z-50 flex flex-col items-start gap-3 transition-all duration-500",
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"
            )}
        >
            {/* Chat Bubble */}
            <div
                className={cn(
                    "overflow-hidden transition-all duration-300",
                    isExpanded ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
                )}
            >
                <div className="rounded-2xl rounded-bl-sm bg-background border shadow-xl p-4 max-w-[260px]">
                    <p className="text-sm font-medium mb-1">Haben Sie eine Frage?</p>
                    <p className="text-xs text-muted-foreground mb-3">
                        Schreiben Sie mir direkt per WhatsApp – ich antworte schnellstmöglich.
                    </p>
                    <a
                        href="https://wa.me/491784912583?text=Hallo%2C%20ich%20habe%20eine%20Frage%20zu%20Ihren%20IT-Services."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-medium text-white hover:bg-[#20BD5A] transition-colors shadow-sm"
                    >
                        <MessageCircle className="h-4 w-4" />
                        Nachricht senden
                    </a>
                </div>
            </div>

            {/* FAB */}
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className={cn(
                    "flex items-center justify-center h-14 w-14 rounded-full shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105",
                    isExpanded
                        ? "bg-muted text-foreground border"
                        : "bg-[#25D366] text-white hover:bg-[#20BD5A]"
                )}
                aria-label={isExpanded ? "WhatsApp-Menü schließen" : "WhatsApp öffnen"}
            >
                {isExpanded ? (
                    <X className="h-6 w-6" />
                ) : (
                    <MessageCircle className="h-6 w-6" />
                )}
            </button>
        </div>
    )
}
